module.exports = __webpack_public_path__ + "media/components/country-flag/static/pk-dea06384ffe4a0130b52f454d40e5677.svg";